import axios from "../../../configs/axios";

export interface Document {
  id: string;
  url: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDocumentRequest {
  url: string;
}

export interface UpdateDocumentRequest {
  url?: string;
}

export const documentsAPI = {
  getAllDocuments: async (search?: string) => {
    const params = search ? { search } : {};
    const response = await axios.get("/admin/documents", { params });
    return response.data.data; // Extract the actual data array
  },

  getDocumentById: async (id: string) => {
    const response = await axios.get(`/admin/documents/${id}`);
    return response.data.data; // Extract the actual data
  },

  createDocument: async (data: CreateDocumentRequest) => {
    const response = await axios.post("/admin/documents", data);
    return response.data.data; // Extract the actual data
  },

  updateDocument: async (id: string, data: UpdateDocumentRequest) => {
    const response = await axios.put(`/admin/documents/${id}`, data);
    return response.data.data; // Extract the actual data
  },

  deleteDocument: async (id: string) => {
    const response = await axios.delete(`/admin/documents/${id}`);
    return response.data; // This returns just the success message, no data field
  },
};
